module.exports = __webpack_public_path__ + "img/dwn_disabled_new.cfc9eb42.svg";